// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.mjs";

function encodeLatLng(lat, lng) {
  return Json_encode.object_({
              hd: [
                "lat",
                lat
              ],
              tl: {
                hd: [
                  "lng",
                  lng
                ],
                tl: /* [] */0
              }
            });
}

function encodeAddressWithLatLng(address) {
  return Json_encode.object_({
              hd: [
                "address",
                address.landmark
              ],
              tl: {
                hd: [
                  "latlng",
                  encodeLatLng(address.location.lat, address.location.lng)
                ],
                tl: /* [] */0
              }
            });
}

function encodeBoundaryValidationData(pickup, drop) {
  return Json_encode.object_({
              hd: [
                "pickup",
                Json_encode.object_({
                      hd: [
                        "latlng",
                        encodeLatLng(pickup.location.lat, pickup.location.lng)
                      ],
                      tl: /* [] */0
                    })
              ],
              tl: {
                hd: [
                  "drop",
                  Json_encode.object_({
                        hd: [
                          "latlng",
                          encodeLatLng(drop.location.lat, drop.location.lng)
                        ],
                        tl: /* [] */0
                      })
                ],
                tl: /* [] */0
              }
            });
}

function encodeCreateLeadData(data) {
  return Json_encode.object_({
              hd: [
                "customer_name",
                data.customer_name
              ],
              tl: {
                hd: [
                  "geo_region_id",
                  data.geo_region_id
                ],
                tl: {
                  hd: [
                    "drop_geo_region_id",
                    data.drop_geo_region_id
                  ],
                  tl: {
                    hd: [
                      "mobile",
                      data.mobile
                    ],
                    tl: {
                      hd: [
                        "shifting_ts",
                        data.shifting_ts
                      ],
                      tl: {
                        hd: [
                          "pickup",
                          encodeAddressWithLatLng(data.pickup)
                        ],
                        tl: {
                          hd: [
                            "drop",
                            encodeAddressWithLatLng(data.drop)
                          ],
                          tl: {
                            hd: [
                              "source",
                              "Website"
                            ],
                            tl: {
                              hd: [
                                "source_detail",
                                null
                              ],
                              tl: {
                                hd: [
                                  "platform",
                                  "web"
                                ],
                                tl: {
                                  hd: [
                                    "web_tracking_id",
                                    Belt_Option.mapWithDefault(data.web_tracking_id, null, (function (prim) {
                                            return prim;
                                          }))
                                  ],
                                  tl: {
                                    hd: [
                                      "customer_uuid",
                                      Belt_Option.mapWithDefault(data.customer_uuid, null, (function (prim) {
                                              return prim;
                                            }))
                                    ],
                                    tl: {
                                      hd: [
                                        "mail_id",
                                        Belt_Option.mapWithDefault(data.mail_id, null, (function (prim) {
                                                return prim;
                                              }))
                                      ],
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function encodeCustomerDetails(name, mobile, mail_id) {
  return Json_encode.object_({
              hd: [
                "name",
                name
              ],
              tl: {
                hd: [
                  "mobile",
                  mobile
                ],
                tl: {
                  hd: [
                    "mail_id",
                    Belt_Option.mapWithDefault(mail_id, null, (function (prim) {
                            return prim;
                          }))
                  ],
                  tl: {
                    hd: [
                      "alternate_mobile",
                      null
                    ],
                    tl: /* [] */0
                  }
                }
              }
            });
}

function encodeShiftReqBasicDetailsData(data) {
  return Json_encode.object_({
              hd: [
                "customer_details",
                encodeCustomerDetails(data.name, data.mobile, data.mail_id)
              ],
              tl: {
                hd: [
                  "geo_region_id",
                  data.geo_region_id
                ],
                tl: {
                  hd: [
                    "shifting_ts",
                    data.shifting_ts
                  ],
                  tl: {
                    hd: [
                      "sr_external_id",
                      Belt_Option.mapWithDefault(data.sr_external_id, null, (function (prim) {
                              return prim;
                            }))
                    ],
                    tl: {
                      hd: [
                        "opp_external_id",
                        Belt_Option.mapWithDefault(data.opp_external_id, null, (function (prim) {
                                return prim;
                              }))
                      ],
                      tl: {
                        hd: [
                          "source",
                          "Website"
                        ],
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            });
}

function encodeLocation(address) {
  return Json_encode.object_({
              hd: [
                "location",
                Json_encode.object_({
                      hd: [
                        "address",
                        address.landmark
                      ],
                      tl: {
                        hd: [
                          "latlng",
                          encodeLatLng(address.location.lat, address.location.lng)
                        ],
                        tl: {
                          hd: [
                            "name",
                            null
                          ],
                          tl: /* [] */0
                        }
                      }
                    })
              ],
              tl: {
                hd: [
                  "floor",
                  0
                ],
                tl: {
                  hd: [
                    "lift_availability",
                    "no_lift"
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function encodeShiftReqLocationDetailsData(sr_external_id, pickup, drop) {
  return Json_encode.object_({
              hd: [
                "sr_external_id",
                sr_external_id
              ],
              tl: {
                hd: [
                  "location_details",
                  Json_encode.object_({
                        hd: [
                          "pickup",
                          encodeLocation(pickup)
                        ],
                        tl: {
                          hd: [
                            "drop",
                            encodeLocation(drop)
                          ],
                          tl: /* [] */0
                        }
                      })
                ],
                tl: {
                  hd: [
                    "source",
                    "Website"
                  ],
                  tl: /* [] */0
                }
              }
            });
}

export {
  encodeLatLng ,
  encodeAddressWithLatLng ,
  encodeBoundaryValidationData ,
  encodeCreateLeadData ,
  encodeCustomerDetails ,
  encodeShiftReqBasicDetailsData ,
  encodeLocation ,
  encodeShiftReqLocationDetailsData ,
}
/* No side effect */
